module.exports = __webpack_public_path__ + "media/images/location de vélo-a4cd895c4ee658e25145a5279ffd2276.svg";